import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useHistory } from "react-router";
import H2Font from "Root/profile/components/common/H2Font";
import RegFont from "Root/profile/components/common/RegFont";
import RoundedGainfulButton from "Root/profile/components/common/RoundedGainfulButton";
import TargetStartImageMobile from "./images/Quiz-Start-Mobile.jpg";
import TargetStartImageDesktop from "./images/Quiz-Start-Desktop.jpg";
import styles from "./styles.module.scss";
import { useScreenWidth } from "Root/profile/components/SubscriptionPageV2/hooks";
const QuizTargetStart = () => {
    const isMobile = useScreenWidth() < 968;
    const history = useHistory();
    const goNext = () => {
        history.push("/quiz-new/target");
    };
    const text = " Our team of experienced Registered Dietitians are in your corner to bridge that gap between where you are now and where you want to be. Answer these few questions for us so we can kick things off!";
    return (_jsxs("div", { className: styles.start_screen, children: [_jsx("div", { className: styles.img, children: _jsx("img", { src: isMobile ? TargetStartImageMobile : TargetStartImageDesktop, alt: "" }) }), _jsx("div", { className: styles.text_right, children: _jsxs("div", { className: styles.text_wrapper, children: [_jsx(H2Font, { children: "Getting To Know You" }), _jsx("div", { className: styles.text, children: _jsx(RegFont, { children: text }) }), _jsx(RoundedGainfulButton, { label: "Get Started", onClick: goNext })] }) })] }));
};
export default QuizTargetStart;
